import { CommonModule } from '@angular/common';
import { Component, HostListener, input, output } from '@angular/core';

/**
 * Lightbox plein écran pour afficher une image en grand.
 * Contrôlée par l'input `src` : visible dès qu'une URL est fournie, masquée
 * quand elle est `null`. Fermeture par clic backdrop, bouton ✕ ou Échap.
 *
 * ```html
 * <app-image-lightbox [src]="lightboxSrc()" (close)="lightboxSrc.set(null)" />
 * ```
 */
@Component({
  selector: 'app-image-lightbox',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-lightbox.component.html',
})
export class ImageLightboxComponent {
  readonly src = input<string | null>(null);
  readonly alt = input<string>('');
  readonly close = output<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.src()) this.close.emit();
  }
}
